{
  "days": {
    "Monday": "Isnin",
    "Tuesday": "Selasa",
    "Wednesday": "Rabu",
    "Thursday": "Khamis",
    "Friday": "Jumaat",
    "Saturday": "Sabtu",
    "Sunday": "Ahad"
  },
  "months": {
    "January": "Januari",
    "February": "Februari",
    "March": "Mac",
    "April": "April",
    "May": "Mei",
    "June": "Jun",
    "July": "Julai",
    "August": "Ogos",
    "September": "September",
    "October": "Oktober",
    "November": "November",
    "December": "Disember"
  },
  "actions": {
    "StartReading": "Mula Membaca",
    "PreviewEdition": "Preview Edition",
    "Download": "Muat Turun",
    "Retry": "Cuba lagi",
    "ReadePaper": "Baca ePaper",
    "TryAgain": "Cuba Lagi"
  },
  "preview": {
    "bottomBar": {
      "subscribe": "Learn about subscription",
      "login": "Already a subscriber? Log in"
    },
    "gate": {
      "title": "Subscribe to view the archive",
      "body": "Subscribers get the full edition, offline reading and sharing, plus archive access.",
      "cta": "Learn about subscription"
    }
  },
  "multiTitle": {
    "st": "",
    "zb": "联合早报",
    "bh": "",
    "tm": "தமிழ் முரசு",
    "sm": "新明日报",
    "bt": "",
    "bm": "",
    "mm" : "",
    "tabla": "Tabla!"
  },
  "tooltip": {
    "Logout": "Log keluar",
    "Onboarding": "Petunjuk",
    "CalenderView": "Paparan kalendar",
    "TileView": "Paparan isu",
    "StartReading": "Klik untuk membaca"
  }
}
